export const FETCH_JOB_FUNCTIONS_SUCCESS = 'FETCH_JOB_FUNCTIONS_SUCCESS';

export const fetchJobFunctionsSuccess = (payload) => ({
  type: FETCH_JOB_FUNCTIONS_SUCCESS,
  payload,
});
